import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { isNil, noop } from 'lodash';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { findCIPayer } from 'services/thirdParty';

export type ThirdPartyPayerListProps = {
  tpid?: number;
  onChange?: (userListByMgid?: any) => void;
  onSelected?: (userListByMgid: any) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  key?: number;
  selectedV: any;
  role?: string;
  ctrid?: number;
};

const ThirdPartyPayerList = ({
  tpid,
  onChange = noop,
  onSelected,
  key,
  selectedV,
  role,
  ctrid,
  ...otherProps
}: ThirdPartyPayerListProps) => {
  const params = useMemo(
    () => ({
      tpid: Number(tpid),
      role: role,
      ctrid: ctrid,
    }),
    [ctrid, role, tpid]
  );

  const { data: listPayer, isFetching } = useQuery(
    ['findCIPayer', params],
    () => findCIPayer(params).then((res) => res.list || []),
    { enabled: !isNil(tpid) && !isNaN(Number(tpid)) }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(listPayer?.find((item) => item.tpid === value)!);
    }
  };
  return (
    <Select
      defaultValue={selectedV}
      key={key}
      allowClear
      onChange={handleChange}
      loading={isFetching}
      {...otherProps}
    >
      {listPayer?.map((payer) => (
        <Select.Option value={payer.tpid} key={payer.tpid}>
          {payer.tpname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ThirdPartyPayerList;
